<script setup lang="ts">
import { ref, computed } from 'vue'
import SectionHeader from '../common/SectionHeader.vue'
import ActionButton from '../common/ActionButton.vue'
import DepartmentGuidelines from './DepartmentGuidelines.vue'
import DressCodeOverview from './dress-code/DressCodeOverview.vue'
import FaqQuestion from './FaqQuestion.vue'
import LastUpdatedDate from './LastUpdatedDate.vue'
import CompanyTopJobs from './CompanyTopJobs.vue'
const props = withDefaults(defineProps<{
  permalink: string
  brand_color?: string
  dress_code?: any
  company_name?: string
  preFetchedData?: any
  logoUrl?: string
}>(), {
  brand_color: '#5F0CE2',
  dress_code: undefined,
  company_name: '',
  preFetchedData: null,
  logoUrl: ''
})
const dressCodeData = computed(() => {
  return props.dress_code && typeof props.dress_code === 'object'
    ? props.dress_code
    : null
})
const preFetchedJobsData = computed(() => {
  return props.preFetchedData?.jobsData || { jobs: [], total: 0, available: 0 }
})
const jobsDataPending = computed(() => {
  return !props.preFetchedData?.jobsData
})
const error = ref(false)
</script>
<template>
  <div>
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-8">
      <SectionHeader :title="`${props.company_name} Dress Code by Job Role`" class="mb-6" />
      <div class="flex">
        <LastUpdatedDate section="dress-code" />
      </div>
      <DressCodeOverview :company-name="props.company_name || ''" :overview="dressCodeData.overview" />
      <SectionHeader :title="'Department Guidelines'" class="mb-6 mt-8" />
      <DepartmentGuidelines :roles="dressCodeData.roles" :brand_color="props.brand_color || '#2563eb'" />
      <SectionHeader :title="'Frequently Asked Questions'" class="mb-6 mt-8" />
      <div class="bg-white rounded-lg my-4">
        <div class="space-y-4">
          <FaqQuestion v-for="(answers, question) in dressCodeData.faq" :key="question" :question="question.toString()"
            :answers="answers" :brand-color="props.brand_color" />
        </div>
      </div>
    </div>
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-8 mb-8">
      <SectionHeader :title="`Latest Job Openings at ${props.company_name}`" class="mb-6">
        <template #action>
          <NuxtLink :to="`/company/${props.permalink}/jobs`" class="hidden sm:block">
            <ActionButton text="See all jobs" icon="i-heroicons-arrow-right" size="sm" variant="ghost"
              :brand-color="props.brand_color" />
          </NuxtLink>
        </template>
      </SectionHeader>
      <div class="block sm:hidden mb-4">
        <NuxtLink :to="`/company/${props.permalink}/jobs`">
          <ActionButton text="See all jobs" icon="i-heroicons-arrow-right" size="sm" variant="ghost"
            class="justify-start" :brand-color="props.brand_color" />
        </NuxtLink>
      </div>
      <CompanyTopJobs :permalink="props.permalink" :location="''" :company_name="props.company_name || ''"
        :pre-fetched-data="preFetchedJobsData" :is-loading="jobsDataPending" :logo_url="props.logoUrl" />
    </div>
  </div>
</template>